
import { Component } from 'vue-property-decorator'
import moment from 'moment'
import { AbstractReportComponent } from './AbstractReportComponent'
import TableKpiCompareItem from '@/components/dashboard/TableKpiCompareItem.vue'
import { KpiItem, FiltersDateFormats, KpisStatusManagement, KpisConnectionReportData, KpisGroupIndicatorsByTime, KpisGroupIndicatorsBySpecificTime, KpisConnectionReportDataUsers, KpisConnectionReportDataUserIndicator } from '@/types/Dashboard'
import LineChart from '@/components/charts/LineChart.vue'
import reportsService from '@/services/ReportsService'
import RoundSlider from 'vue-round-slider'

const COLORS = [
  '#37bc9b', '#f6bb42', '#3bafda', '#967adc', '#d770ad', '#4a89dc', '#999999',
  '#1c7c66', '#a78034', '#285d70', '#6442b9', '#bd3185', '#3d4753', '#383838',
  '#0c4739', '#926813', '#16313b', '#4f4174', '#c779a8', '#6a7c92', '#855858',
  '#008163', '#857149', '#0080af', '#5b536e', '#806374', '#323f50', '#491b1b',
  '#24a587', '#33312c', '#5895ac', '#2f2644', '#503a47', '#1c3657', '#292525',
  '#19641c', '#6c7c46', '#1f4b8f', '#7a5991', '#3f203d', '#272b61', '#724343',
  '#37bc9b', '#f6bb42', '#3bafda', '#967adc', '#d770ad', '#4a89dc', '#999999',
  '#1c7c66', '#a78034', '#285d70', '#6442b9', '#bd3185', '#3d4753', '#383838',
  '#0c4739', '#926813', '#16313b', '#4f4174', '#c779a8', '#6a7c92', '#855858',
  '#008163', '#857149', '#0080af', '#5b536e', '#806374', '#323f50', '#491b1b',
  '#24a587', '#33312c', '#5895ac', '#2f2644', '#503a47', '#1c3657', '#292525',
  '#19641c', '#6c7c46', '#1f4b8f', '#7a5991', '#3f203d', '#272b61', '#724343',
  '#37bc9b', '#f6bb42', '#3bafda', '#967adc', '#d770ad', '#4a89dc', '#999999',
  '#1c7c66', '#a78034', '#285d70', '#6442b9', '#bd3185', '#3d4753', '#383838',
  '#0c4739', '#926813', '#16313b', '#4f4174', '#c779a8', '#6a7c92', '#855858',
  '#008163', '#857149', '#0080af', '#5b536e', '#806374', '#323f50', '#491b1b',
  '#24a587', '#33312c', '#5895ac', '#2f2644', '#503a47', '#1c3657', '#292525',
  '#19641c', '#6c7c46', '#1f4b8f', '#7a5991', '#3f203d', '#272b61', '#724343',
  '#37bc9b', '#f6bb42', '#3bafda', '#967adc', '#d770ad', '#4a89dc', '#999999',
  '#1c7c66', '#a78034', '#285d70', '#6442b9', '#bd3185', '#3d4753', '#383838'
]

@Component({
  components: {
    TableKpiCompareItem,
    LineChart,
    RoundSlider
  },
  filters: {
    formatNum (value: number) {
      return value.toLocaleString('en')
    }
  }
})
export default class ReportConexion extends AbstractReportComponent {
  usersData: KpisConnectionReportData[] = []
  mainKpis = new KpisStatusManagement()
  groupsAverageUsersConnnected: any[] = []
  hoursWithUsersConnnected: any[] = []

  initHour = 0
  endHour = 23

  sliderValue = '0,23'

  // Main KPIs
  kpis: KpiItem[] = []

  searchUsers = ''

  tableUsernameSortDirAsc = true
  tableAmountSortDirAsc = false
  gridGroupDetailShowBars = true
  gridGroupDetailShowValue = true

  // Charts
  chartsDataCollection: any[] = []
  globalChartDataCollection: any = {}
  chartDataGlobal: any = {}
  gridUsersDetail: KpisConnectionReportDataUsers[] = []
  gridGroupsDetail: KpisGroupIndicatorsByTime[] = []
  groupSelectedData: KpisConnectionReportData
  refreshingCharts = false

  options = {
    responsive: true,
    maintainAspectRatio: false,
    tooltips: {
      callbacks: {
        label: (tooltipItem: any, data: any) => {
          let valueNum = Number(data.datasets[0].data[tooltipItem.index] || 0)
          return valueNum.toLocaleString('en')
        }
      }
    }
  }

  chartsTooltips = {
    callbacks: {
      label: (tooltipItem: any) => {
        let valueNum = Number(tooltipItem.yLabel || 0)
        return valueNum.toLocaleString('en') + '%'
      },
      title: (tooltipItem: any) => {
        return tooltipItem[0].label + ' hrs.'
      }
    }
  }

  chartsScales = {
    yAxes: [{
      ticks: {
        beginAtZero: true,
        callback: (value: any) => {
          let valueNum = Number(value || 0)
          return valueNum.toLocaleString('en') + '%'
        }
      }
    }]
  }

  chartsPlugins = {
    datalabels: {
      display: false
    }
  }

  created () {
    this.$store.commit('global/updateFiltersReportConexion')
  }

  mounted () {
    this.initialPageTitle = document.title
    this.filter(this.$route.query as any)
    this.$root.$on('export-report', this.exportReport)
    window.addEventListener('afterprint', this.afterPrintPdfReport)
  }

  beforeDestroy () {
    document.title = this.initialPageTitle
    this.$root.$off('export-report', this.exportReport)
    window.removeEventListener('afterprint', this.afterPrintPdfReport)
  }

  get filtersRequiredSet () {
    return !!this.filters.group
  }

  get userGroupsDictionary () {
    return this.$store.state.global.userGroupsDictionary
  }

  async refreshData () {
    if (!this.filtersRequiredSet) return

    this.loadingData = true
    this.usersData = []
    this.$store.commit('global/lockReportFilters', true)

    this.tableUsernameSortDirAsc = true
    this.tableAmountSortDirAsc = false

    try {
      // 1. Get data
      let usersData: KpisConnectionReportData[] = []
      await reportsService.getReporteConexion(this.filters)
        .then((response) => { usersData = response })
        .catch((error) => {
          this.$bvToast.toast(
            `Error al consultar la información para el reporte: ${error.response.data.message}.
            Por favor, intenta con otros valores de consulta.
            `,
            { title: 'Error en la consulta', variant: 'danger', autoHideDelay: 6000 })
          this.endPrint()
          this.$store.commit('global/lockReportFilters', false)
        })

      // 2. Set group name and sort by it
      usersData.forEach((it) => {
        it.groupName = this.userGroupsDictionary[it.groupId]
        it.users = it.users.sort((a, b) => (a.user.toLowerCase() > b.user.toLowerCase()) ? 1 : -1)
        it.users.forEach(usr => {
          usr.group = it.groupName
        })
      })
      usersData.sort((a, b) => (a.groupName.toLowerCase() > b.groupName.toLowerCase()) ? 1 : -1)

      // Copy all users from subgroup into the selected group
      this.groupSelectedData = (usersData.find(it => it.groupId === this.filters.group.toString()) || { users: [] as KpisConnectionReportDataUsers[] }) as KpisConnectionReportData
      usersData = usersData.filter(it => it.groupId !== this.filters.group.toString())
      usersData.forEach((it) => {
        this.groupSelectedData.users = this.groupSelectedData.users.concat(it.users)
        this.groupSelectedData.totalUsers += it.totalUsers
      })

      // Add selected group at the begining
      usersData.unshift(this.groupSelectedData as KpisConnectionReportData)

      this.usersData = usersData

      this.gridUsersDetail = this.groupSelectedData.users

      this.gridGroupsDetail = this.usersData.map(it => {
        return reportsService.getGroupIndicatorsByTimeKpis(it)
      })

      this.refreshMainKpis()
      this.refreshChartsKpis()
    } finally {
      setTimeout(() => {
        this.loadingData = false
        this.$store.commit('global/lockReportFilters', false)
      }, 500)
    }
  }

  refreshFiltersInfo () {
    let result = []
    if (this.filtersStore.group) {
      result.push('Grupo: ' + this.filtersStore.groupName)
    }

    const date = 'Del ' + moment(this.filtersStore.endDate, FiltersDateFormats.QUERY_STRING).format('D [de] MMMM [de] YYYY')
    result.push(date)

    result.push(`de las ${this.initHour}:00 hrs. a las ${this.endHour}:59 hrs.`)

    this.filtersHead = result.join(', ')
  }

  refreshMainKpis () {
    this.kpis = []
    let currentItem: KpisGroupIndicatorsBySpecificTime

    let totalUsersConnectedByHour = [...Array(24).keys()].map(i => 0)
    let maxUsersConnected = 0

    const mainGroupDetail = this.gridGroupsDetail[0]
    const subGroups = this.gridGroupsDetail.filter((it, index) => index > 0)

    let averageConnection = 0
    for (let i = this.initHour; i <= this.endHour; i++) {
      currentItem = mainGroupDetail[i as keyof KpisGroupIndicatorsByTime] as KpisGroupIndicatorsBySpecificTime
      totalUsersConnectedByHour[i] += currentItem.numberUsersAtTime
      averageConnection += currentItem.averageConnectedUsers
    }
    averageConnection = averageConnection / (this.endHour - this.initHour + 1)

    let groupsAverageUsersConnnected: any[] = []
    subGroups.forEach(it => {
      let averageConnection = 0
      for (let i = this.initHour; i <= this.endHour; i++) {
        currentItem = it[i as keyof KpisGroupIndicatorsByTime] as KpisGroupIndicatorsBySpecificTime
        averageConnection += currentItem.averageConnectedUsers
      }
      averageConnection = averageConnection / (this.endHour - this.initHour + 1)
      groupsAverageUsersConnnected.push({ group: it.groupName, average: +averageConnection.toFixed(1) })
    })

    // Max users connected in an hour
    maxUsersConnected = Math.max.apply(null, totalUsersConnectedByHour)

    // Hour with the most users connected
    this.hoursWithUsersConnnected = totalUsersConnectedByHour.map((it, index) => { return { hour: index, usersCount: it } }).filter(it => it.usersCount > 0).sort((a, b) => (a.usersCount < b.usersCount) ? 1 : -1)

    // Group with the most users connected
    this.groupsAverageUsersConnnected = groupsAverageUsersConnnected.filter(it => it.average > 0).sort((a, b) => (a.average < b.average) ? 1 : -1)

    // Adding Kpis results to the list ********************************************
    this.kpis.push(
      KpiItem.getInstance().withName('Promedio general de<br>usuarios conectados').withValue(+averageConnection.toFixed(1)).withSuffix('%').withIcon('fa-user-check').withColor('green')
    )
    this.kpis.push(
      KpiItem.getInstance().withName('Máximo de usuarios<br>conectados en una hora').withValue(maxUsersConnected).withIcon('fa-clock').withColor('purple')
    )
  }

  refreshGroupsWithMostUsersConnectedKpi () {

  }

  refreshChartsKpis () {
    this.refreshingCharts = true

    this.chartsDataCollection = this.gridGroupsDetail.map((it, index) => {
      let labels = []
      let values = []
      for (let i = this.initHour; i <= this.endHour; i++) {
        labels.push(i)
        values.push((it[i as keyof KpisGroupIndicatorsByTime] as KpisGroupIndicatorsBySpecificTime).averageConnectedUsers)
      }
      return {
        name: it.groupName,
        totalUsers: 5,
        labels: labels,
        datasets: [
          {
            label: 'Usuarios activos',
            lineTension: 0.4,
            borderColor: COLORS[index],
            backgroundColor: COLORS[index] + '99',
            fill: true,
            data: values
          }
        ]
      }
    })

    this.globalChartDataCollection = {
      labels: this.chartsDataCollection[0].labels,
      datasets: this.chartsDataCollection.map((it, index) => {
        return {
          label: it.name,
          lineTension: 0.4,
          borderColor: it.datasets[0].borderColor,
          fill: false,
          data: it.datasets[0].data
        }
      })
    }

    setTimeout(() => {
      this.refreshingCharts = false
    }, 500)
  }

  getGroupHourColor (percentValue: number) {
    if (percentValue >= 0 && percentValue < 40) {
      return 'red'
    }

    if (percentValue >= 40 && percentValue < 70) {
      return 'yellow'
    }

    if (percentValue >= 70 && percentValue < 90) {
      return 'green-light'
    }

    if (percentValue >= 90) {
      return 'green-strong'
    }
  }

  onHourSliderChange (event: any) {
    const values = event.value.split(',')
    this.initHour = +values[0]
    this.endHour = +values[1]
    this.refreshMainKpis()
    this.refreshChartsKpis()
    this.refreshFiltersInfo()
  }

  resetTimeRange () {
    this.sliderValue = '0,23'
    this.initHour = 0
    this.endHour = 23
    this.refreshMainKpis()
    this.refreshChartsKpis()
    this.refreshFiltersInfo()
  }

  sortSourceDataByGroupName () {
    this.usersData.sort((a, b) => (a.groupName > b.groupName) ? 1 : -1)
  }

  exportReport (reportType: string) {
    switch (reportType) {
      case 'pdf':
        this.generatePdfReport()
        break
      case 'csv':
        this.generateCsvReport()
        break
    }
  }

  generatePdfReport () {
    this.validateRatio()
    this.searchUsers = ''
    this.startPrint()
    setTimeout(() => {
      window.print()
    }, 1200)
  }

  generateCsvReport () {
    const periodTitle = moment(this.filtersStore.endDate, FiltersDateFormats.QUERY_STRING).format('DDMMYYYY')

    if (this.gridUsersDetail.length) {
      // HEADER
      let csv = 'GRUPO,USUARIO,'
      for (let i = this.initHour; i <= this.endHour; i++) {
        csv += i + ' hrs.,'
      }
      csv += '\n'

      // ROWS
      for (let it of this.gridUsersDetail) {
        csv += `${it.group},${it.user},`
        for (let i = this.initHour; i <= this.endHour; i++) {
          csv += ((it[i as keyof KpisConnectionReportDataUsers] as KpisConnectionReportDataUserIndicator).status ? 'X' : '') + ','
        }
        csv += '\n'
      }

      let element = this.$refs.csvDownload as any
      element.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv)
      element.target = '_blank'
      element.download = `${periodTitle}_${this.filtersStore.groupName}_RptConexionUsuarios.csv`
      element.click()
    }

    if (this.gridGroupsDetail.length) {
      // HEADER
      let csv = 'GRUPO,'
      for (let i = this.initHour; i <= this.endHour; i++) {
        csv += i + ' hrs.,'
      }
      csv += '\n'

      // ROWS
      for (let it of this.gridGroupsDetail) {
        csv += `${it.groupName},`
        for (let i = this.initHour; i <= this.endHour; i++) {
          csv += `${(it[i as keyof KpisGroupIndicatorsByTime] as KpisGroupIndicatorsBySpecificTime).numberUsersAtTime} (${(it[i as keyof KpisGroupIndicatorsByTime] as KpisGroupIndicatorsBySpecificTime).averageConnectedUsers}%),`
        }
        csv += '\n'
      }

      let element = this.$refs.csvDownload2 as any
      element.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv)
      element.target = '_blank'
      element.download = `${periodTitle}_${this.filtersStore.groupName}_RptConexionGrupos.csv`
      element.click()
    }
  }

  afterPrintPdfReport () {
    this.endPrint()
    document.title = this.initialPageTitle
  }
}
